/**
 * Global Quick Actions (STEP 4) — every entry deep-links to a real,
 * already-certified page from Stages F1-F4. No new workflow is
 * invented here; this is purely a fast-launch surface over existing
 * routes, permission-gated identically to `nav-config.ts`.
 */
import { PatientPermissions, AppointmentPermissions, FinancialPermissions, ClinicalPermissions } from '@nexao/contracts';

export interface QuickAction {
  id: string;
  label: string;
  keywords: string[];
  requiredPermissions: string[];
  /** Real route to navigate to, or `null` for an in-page action (e.g. Switch Branch opens a dialog instead of navigating). */
  path: string | null;
}

export const QUICK_ACTIONS: QuickAction[] = [
  {
    id: 'register-patient',
    label: 'Register Patient',
    keywords: ['register', 'new patient', 'registration'],
    requiredPermissions: [PatientPermissions.PATIENT_REGISTER],
    path: '/patients/register',
  },
  {
    id: 'search-patient',
    label: 'Search Patient',
    keywords: ['find patient', 'lookup patient'],
    requiredPermissions: [PatientPermissions.PATIENT_SEARCH],
    path: '/patients',
  },
  {
    id: 'book-appointment',
    label: 'Book Appointment',
    keywords: ['book', 'schedule', 'appointment'],
    requiredPermissions: [AppointmentPermissions.APPOINTMENT_BOOK],
    path: '/appointments/book',
  },
  {
    id: 'search-appointment',
    label: 'Search Appointment',
    keywords: ['find appointment', 'lookup appointment'],
    requiredPermissions: [AppointmentPermissions.APPOINTMENT_SCHEDULE_MANAGE],
    path: '/appointments/lookup',
  },
  {
    id: 'start-encounter',
    label: 'Start Encounter',
    keywords: ['encounter', 'clinical', 'visit'],
    requiredPermissions: [ClinicalPermissions.CLINICAL_CREATE],
    path: '/clinical/workspace',
  },
  {
    id: 'create-bill',
    label: 'Create Bill',
    keywords: ['bill', 'charge', 'invoice'],
    requiredPermissions: [FinancialPermissions.FINANCIAL_BILLING_COMPUTE],
    path: '/billing/workspace',
  },
  {
    id: 'collect-payment',
    label: 'Collect Payment',
    keywords: ['payment', 'cashier', 'collect'],
    requiredPermissions: [FinancialPermissions.FINANCIAL_PAYMENT_PROCESS],
    path: '/billing/cashier',
  },
  {
    id: 'switch-branch',
    label: 'Switch Branch',
    keywords: ['branch', 'hospital', 'location'],
    requiredPermissions: [],
    path: null,
  },
];
